import React from 'react'
import { Loading } from '@myxplor/ui'
import DefaultForm from '../../../../ui/forms/default-form'
import { UpdateB2BDeviceDone, UpdateB2BDeviceFormFields } from './form'
import { changeB2BDevice } from '../../../../helpers/analytics'

const available = ({ available_actions }) =>
  (available_actions || []).includes('update_b2b')

const apiEndPoint = (record) => {
  const org_id = record.device_registration.organisation_id
  return `/api/device-registrations/${org_id}/update`
}

const submitEndPoint = (record) =>
  process.env.REACT_APP_API_HOST + apiEndPoint(record)

const formValue = 'update_b2b_device_personnel'

const updateB2BDeviceForm = (record) => ({ handleSuccess }) => {
  if (!record) {
    return <Loading>Loading B2B Device Registration information</Loading>
  }

  return (
    <DefaultForm
      onBeforeSubmit={changeB2BDevice}
      url={submitEndPoint(record)}
      value={formValue}
      formComponent={(props) => UpdateB2BDeviceFormFields({ ...props, 
        provider_registration_id: record.ccs_provider_registration_id,
        mancon_id: record.personnel.gov_person_id
      }
        )}
      label='Update B2B Device'
      loadingTitle='Updating B2B Device...'
      handleSuccess={(payload) =>
        handleSuccess(
          {
            [formValue]: <UpdateB2BDeviceDone payload={payload} />,
          },
          formValue
        )
      }
    />
  )
}


const updateB2BDevice = ({ record, refresh_b2b_device_list, apiEndPoint }) =>
  available(record)
    ? {
      label: 'Update B2B Device',
      value: formValue,
      actionForm: updateB2BDeviceForm(record),
      onCompletePreserveAction: true,
      onComplete: () => refresh_b2b_device_list(apiEndPoint),
    }
    : null

export default updateB2BDevice



// WEBPACK FOOTER //
// ./src/providers-registrations/b2b-device-list/actions/update-action/index.js